import { jsx } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import { Box } from "@mui/material";
function SectionHeaderBox({
  children,
  minHeight
}) {
  const { gray } = useColors();
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        px: 3,
        py: 2,
        minHeight,
        bgcolor: gray[50],
        borderBottom: `1px solid ${gray[200]}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        // 모바일에서 제목과 액션이 한 줄에 안 들어가면 액션을 다음 줄로 내린다
        flexWrap: { mobile: "wrap", tablet: "nowrap" },
        rowGap: 1.5
      },
      children
    }
  );
}
export {
  SectionHeaderBox
};
